import { render, staticRenderFns } from "./DeactivateModal.vue?vue&type=template&id=558ed906&scoped=true"
import script from "./DeactivateModal.vue?vue&type=script&lang=js"
export * from "./DeactivateModal.vue?vue&type=script&lang=js"
import style0 from "./DeactivateModal.vue?vue&type=style&index=0&id=558ed906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ed906",
  null
  
)

export default component.exports